import axios from "axios";
import { getToken, getTokenHeader } from "../../../../Common/Token";
import { sendNewMobileNumberUrl } from "../urls";

export const updateNewMobileNumberAction = async (data) => {
    return new Promise(async (next) => {
        const token = await getToken();
        await axios
            .patch(sendNewMobileNumberUrl(), data, getTokenHeader(token))
            .then(async ({ data }) => {
                return next(data);
            })
            .catch((err) => {
                return err;
            });
    });
};